var _linearGradient, _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _circle3, _circle4, _circle5, _path9, _path10, _path11, _circle6, _circle7, _circle8, _circle9, _circle10, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarbadosSuperLotto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 209 209",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 0.984,
    x2: 0.5,
    y2: 0.038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#005faf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#26a9e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#24a6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#1f9cd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#168bcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#0a73bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005faf"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 1589.393,
    cy: 26.181,
    r: 15.849,
    gradientTransform: "matrix(.2467 -.1749 1.425 2.0098 -404.489 336.277)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 1790.929,
    cy: 38.971,
    r: 15.849,
    gradientTransform: "matrix(-.2467 -.1749 -1.425 2.0098 680.791 345.825)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 66.085,
    cy: 18.698,
    r: 44.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 18.958,
    cy: 76.302,
    r: 18.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 190.58,
    cy: 76.302,
    r: 18.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 155.906,
    cy: 51.939,
    r: 22.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 53.34,
    cy: 51.939,
    r: 22.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 104.396,
    cy: 34.505,
    r: 31.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 1693.355,
    cy: 18.869,
    r: 15.849,
    gradientTransform: "matrix(.2861 -.09801 .6258 1.8267 -445.094 209.106)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 1972.107,
    cy: 29.775,
    r: 15.849,
    gradientTransform: "matrix(-.2861 -.09801 -.6258 1.8267 740.449 216.506)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 2127.54,
    cy: 31.683,
    r: 15.849,
    gradientTransform: "matrix(-.3024 .00308 .0366 3.5883 746.834 -48.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 19.976,
    cy: 33.396,
    r: 56.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#f9f9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#e6e9eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#c9cfd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#a0aab1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#7d8b94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#829099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#929ea5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#acb5bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#d0d5d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 191.599,
    cy: 33.396,
    r: 56.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#f9f9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#e6e9eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#c9cfd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#a0aab1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#7d8b94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#829099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#929ea5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#acb5bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#d0d5d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 157.113,
    cy: 1.641,
    r: 66.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#f9f9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#e6e9eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#c9cfd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#a0aab1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#7d8b94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#829099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#929ea5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#acb5bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#d0d5d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 54.547,
    cy: 1.641,
    r: 66.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#f9f9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#e6e9eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#c9cfd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#a0aab1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#7d8b94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#829099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#929ea5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#acb5bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#d0d5d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 106.077,
    cy: -34.31,
    r: 93.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#f9f9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#e6e9eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#c9cfd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#a0aab1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#7d8b94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#829099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#929ea5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#acb5bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#d0d5d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.626 38.18c-4.266 0-7.757 3.491-7.757 7.757v117.127c0 4.266 3.491 7.757 7.757 7.757h116.972c4.266 0 7.757-3.491 7.757-7.757V45.936c0-4.266-3.491-7.757-7.757-7.757H45.626z",
    fill: "#005d9b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m171.829 164.615-10.084 6.438h-13.497l23.581-19.935v13.497zm-44.989 6.438 44.989-75.473V63.467L122.03 171.053h4.809zm44.989-48.402-38.008 48.402h6.904l31.105-31.88v-16.522zm-56.935 48.402 35.681-133.649-30.639.853-11.635 132.796h6.593zm-39.947 0-38.008-48.402v16.522l31.105 31.88h6.904zm-14.428 0-23.581-19.935v13.497l10.084 6.438h13.497zm39.87 0L88.754 38.335l-30.562-.931 35.681 133.649h6.516zm-13.652 0L36.939 63.467V95.58l44.989 75.473h4.809z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m38.025 106.672-5.352 3.801a185.736 185.736 0 0 0 8.377 12.876c8.998 12.721 17.763 21.952 19.547 20.711s-4.111-12.566-13.109-25.287c-3.335-4.576-6.516-8.688-9.463-12.101z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m169.967 106.672 5.352 3.801a185.736 185.736 0 0 1-8.377 12.876c-8.998 12.721-17.763 21.952-19.547 20.711s4.111-12.566 13.109-25.287a223.93 223.93 0 0 1 9.463-12.101z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.626 176.25a13.18 13.18 0 0 1-13.186-13.186V45.936A13.18 13.18 0 0 1 45.626 32.75h116.972a13.18 13.18 0 0 1 13.186 13.186v117.127a13.18 13.18 0 0 1-13.186 13.186H45.626zm0-135.743a5.397 5.397 0 0 0-5.43 5.43v117.127a5.397 5.397 0 0 0 5.43 5.43h116.972a5.397 5.397 0 0 0 5.43-5.43V45.936a5.397 5.397 0 0 0-5.43-5.43H45.626z",
    fill: "#602b01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.087 38.335H47.876c-3.258 3.18-5.119 6.981-5.119 11.092 0 11.17 14.195 20.323 31.725 20.323s31.725-9.153 31.725-20.4c0-4.034-1.939-7.834-5.119-11.015z",
    fill: "url(#d)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.626 174.699a11.62 11.62 0 0 1-11.635-11.635V45.936a11.62 11.62 0 0 1 11.635-11.635h116.972a11.62 11.62 0 0 1 11.635 11.635v117.127a11.62 11.62 0 0 1-11.635 11.635H45.626zm0-135.743a6.95 6.95 0 0 0-6.981 6.981v117.127a6.95 6.95 0 0 0 6.981 6.981h116.972a6.95 6.95 0 0 0 6.981-6.981V45.936a6.95 6.95 0 0 0-6.981-6.981H45.626z",
    fill: "#ae8b2d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M162.598 173.923H45.626c-5.973 0-10.859-4.887-10.859-10.859V45.936c0-5.973 4.887-10.859 10.859-10.859h116.972c5.973 0 10.859 4.887 10.859 10.859v117.127c0 5.973-4.887 10.859-10.859 10.859zM45.626 38.18c-4.266 0-7.757 3.491-7.757 7.757v117.127c0 4.266 3.491 7.757 7.757 7.757h116.972c4.266 0 7.757-3.491 7.757-7.757V45.936c0-4.266-3.491-7.757-7.757-7.757H45.626z",
    fill: "#e2d112"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.947,
    cy: 91.934,
    r: 14.738,
    fill: "url(#e)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.053,
    cy: 91.934,
    r: 14.738,
    fill: "url(#f)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.137,
    cy: 73.008,
    r: 17.453,
    fill: "url(#g)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.553,
    cy: 73.008,
    r: 17.453,
    fill: "url(#h)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.19,
    cy: 59.511,
    r: 24.279,
    fill: "url(#i)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m62.924 82.626-6.283 2.172a111.902 111.902 0 0 0 3.335 11.635c3.956 11.558 8.843 20.323 10.859 19.625 2.094-.698.543-10.627-3.413-22.184-1.474-4.266-3.025-8.067-4.499-11.247z",
    fill: "url(#j)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m145.456 82.626 6.283 2.172a111.902 111.902 0 0 1-3.335 11.635c-3.956 11.558-8.843 20.323-10.859 19.625-2.094-.698-.543-10.627 3.413-22.184 1.474-4.266 3.025-8.067 4.499-11.247z",
    fill: "url(#k)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m100.854 70.448 6.593-.078c.465 6.438.776 14.117.853 22.339.233 22.65-1.319 41.033-3.491 41.033s-4.111-18.306-4.344-40.956c-.078-8.222.078-15.901.388-22.339z",
    fill: "url(#l)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.947,
    cy: 89.607,
    r: 13.497,
    fill: "url(#m)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.053,
    cy: 89.607,
    r: 13.497,
    fill: "url(#n)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.137,
    cy: 70.681,
    r: 16.056,
    fill: "url(#o)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.553,
    cy: 70.681,
    r: 16.056,
    fill: "url(#p)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.19,
    cy: 57.184,
    r: 22.339,
    fill: "url(#q)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m30.966 96.355 2.637-3.18c1.241 1.008 2.87 1.706 4.111 1.706 1.396 0 2.017-.465 2.017-1.241 0-.853-.931-1.086-2.405-1.706l-2.172-1.008c-1.939-.776-3.568-2.405-3.568-4.964 0-3.025 2.715-5.507 6.593-5.507 2.017 0 4.266.776 5.895 2.405l-2.327 2.948c-1.164-.853-2.249-1.241-3.568-1.241-1.164 0-1.862.388-1.862 1.164 0 .853 1.008 1.164 2.637 1.784l2.172.853c2.172.853 3.491 2.405 3.491 4.809 0 3.025-2.482 5.662-6.904 5.662-2.327.078-4.887-.776-6.748-2.482zM56.408 70.68v-9.308h5.119v9.929c0 3.258.931 4.421 2.948 4.421s2.948-1.164 2.948-4.421v-9.929h4.964v9.386c0 6.205-2.482 9.075-7.912 9.075-5.43-.078-8.067-2.948-8.067-9.153zm40.413-28.079h9.696c5.74 0 10.704 2.172 10.704 8.92 0 6.516-5.042 9.386-10.549 9.386h-2.87v8.455h-6.981V42.601zm9.541 12.644c2.792 0 4.034-1.396 4.034-3.801s-1.551-3.258-4.189-3.258h-2.327v7.059h2.482zm32.501 6.283h10.782v3.956h-6.361v2.792h5.43v4.034h-5.43v3.18h6.593v3.956h-11.015V61.528zm40.335 37-3.723-6.904c1.629-.931 2.792-2.56 2.792-5.119 0-4.421-3.18-5.74-6.826-5.74h-6.438V98.45h4.499v-5.973h1.706l2.948 5.973h5.042zm-9.696-13.962h1.629c1.784 0 2.715.465 2.715 2.017s-.931 2.327-2.715 2.327h-1.629v-4.344z",
    fill: "#d61220"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M146.154 164.305a10.231 10.231 0 0 1-10.239-10.239v-40.723a10.231 10.231 0 0 1 10.239-10.239h2.87a10.231 10.231 0 0 1 10.239 10.239v40.723a10.231 10.231 0 0 1-10.239 10.239h-2.87zm.465-52.358c-.543 0-1.086.465-1.086 1.086v41.421c0 .543.465 1.086 1.086 1.086h1.939c.543 0 1.086-.465 1.086-1.086v-41.421c0-.543-.465-1.086-1.086-1.086h-1.939zm-67.018 52.358a10.231 10.231 0 0 1-10.239-10.239v-40.723a10.231 10.231 0 0 1 10.239-10.239h2.87a10.231 10.231 0 0 1 10.239 10.239v40.723a10.231 10.231 0 0 1-10.239 10.239h-2.87zm.465-52.358c-.543 0-1.086.465-1.086 1.086v41.421c0 .543.465 1.086 1.086 1.086h1.939c.543 0 1.086-.465 1.086-1.086v-41.421c0-.543-.465-1.086-1.086-1.086h-1.939zm38.163 50.962v-48.402h-7.291v48.402h-9.618v-48.402h-6.748v-10.084h40.025v10.084h-6.748v48.402h-9.618zm-59.882 0c-5.275 0-9.618-4.344-9.618-9.618v-48.945h9.618v48.402h9.308v10.084h-9.308z",
    fill: "#602b01"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119.626 161.512v-47.859a.527.527 0 0 0-.543-.543h-8.92a.527.527 0 0 0-.543.543v47.859h-6.826v-47.859a.527.527 0 0 0-.543-.543h-6.128v-7.291h37.232v7.291h-6.128a.527.527 0 0 0-.543.543v47.859h-7.059zm-53.289 0v-7.291h-7.912a1.388 1.388 0 0 1-1.396-1.396v-47.084h-6.826v47.549c0 4.499 3.723 8.222 8.222 8.222h7.912zm16.134 1.396a8.84 8.84 0 0 0 8.843-8.843v-40.723a8.84 8.84 0 0 0-8.843-8.843h-2.87a8.84 8.84 0 0 0-8.843 8.843v40.723a8.84 8.84 0 0 0 8.843 8.843h2.87zm-.465-52.358c1.319 0 2.482 1.086 2.482 2.482v41.421c0 1.319-1.086 2.482-2.482 2.482h-1.939c-1.319 0-2.482-1.086-2.482-2.482v-41.421c0-1.319 1.086-2.482 2.482-2.482h1.939zm67.018 52.358a8.84 8.84 0 0 0 8.843-8.843v-40.723a8.84 8.84 0 0 0-8.843-8.843h-2.87a8.84 8.84 0 0 0-8.843 8.843v40.723a8.84 8.84 0 0 0 8.843 8.843h2.87zm-.465-52.358c1.319 0 2.482 1.086 2.482 2.482v41.421c0 1.319-1.086 2.482-2.482 2.482h-1.939c-1.319 0-2.482-1.086-2.482-2.482v-41.421c0-1.319 1.086-2.482 2.482-2.482h1.939z",
    fill: "#ae8b2d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96.898 106.672h35.371v5.43h-5.197c-.853 0-1.474.698-1.474 1.474v46.928h-4.964v-46.928c0-.853-.698-1.474-1.474-1.474h-8.92c-.853 0-1.474.698-1.474 1.474v46.928h-4.964v-46.928c0-.853-.698-1.474-1.474-1.474h-5.43v-5.43zm-40.801 46.075v-46.075h-4.964v46.618a7.284 7.284 0 0 0 7.291 7.291h7.059v-5.43h-6.981c-1.396-.078-2.405-1.086-2.405-2.405zm34.285-39.404v40.723a7.95 7.95 0 0 1-7.912 7.912H79.6a7.95 7.95 0 0 1-7.912-7.912v-40.723a7.95 7.95 0 0 1 7.912-7.912h2.87c4.421 0 7.912 3.491 7.912 7.912zm-4.964-.31a3.393 3.393 0 0 0-3.413-3.413h-1.939a3.393 3.393 0 0 0-3.413 3.413v41.421a3.393 3.393 0 0 0 3.413 3.413h1.939a3.393 3.393 0 0 0 3.413-3.413v-41.421zm71.517.31v40.723a7.95 7.95 0 0 1-7.912 7.912h-2.87a7.95 7.95 0 0 1-7.912-7.912v-40.723a7.95 7.95 0 0 1 7.912-7.912h2.87a7.896 7.896 0 0 1 7.912 7.912zm-5.042-.31a3.393 3.393 0 0 0-3.413-3.413h-1.939a3.393 3.393 0 0 0-3.413 3.413v41.421a3.393 3.393 0 0 0 3.413 3.413h1.939a3.393 3.393 0 0 0 3.413-3.413v-41.421z",
    fill: "#e2d112"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarbadosSuperLotto);
export default __webpack_public_path__ + "static/media/barbados_super_lotto.192c6501cf525a68bbd83c22d53a2feb.svg";
export { ForwardRef as ReactComponent };